import { ONE_YEAR_SECONDS, getCookie, setCookie } from '@growtherapy/analytics';
import { GROW_LANG_COOKIE_TOKEN_NAME, LOCALE_DEFAULT } from '@growtherapy/i18n';

export function getStoredLanguagePreference(): string {
  const value = getCookie(GROW_LANG_COOKIE_TOKEN_NAME);
  if (typeof value === 'string' && value.length > 0) {
    return value;
  }
  return LOCALE_DEFAULT;
}

export function setStoredLanguagePreference(locale: string): void {
  setCookie(GROW_LANG_COOKIE_TOKEN_NAME, locale, ONE_YEAR_SECONDS);
}
